import useSWRMutation from 'swr/mutation';
import { fetchProfile, updateProfile } from './data-source';
import { atom, useAtom } from 'jotai';
import { IUser } from '@shared/types.ts';

export const userAtom = atom<IUser | null>(null);

export function useUser() {
  const [data, setData] = useAtom(userAtom);
  const profile = useSWRMutation('/api/profile', fetchProfile, {
    onSuccess: (response) => {
      if (response.data.data) setData(response.data.data);
    },
  });
  const update = useSWRMutation('/api/profile', updateProfile);

  function logout() {
    localStorage.clear();
    window.location.href = '/';
  }

  return {
    fetchUser: profile.trigger,
    isAuthenticated: !!data,
    isUseCache: !data,
    user: data,
    updateUser: update.trigger,
    logout,
  };
}
